import { STATUS_LABELS, STATUS_COLORS, STATUS_ORDER } from '../../lib/format';
import type { TicketStatus } from '../../lib/types';
import { clsx } from 'clsx';

interface Props {
  status: TicketStatus;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'sm' }: Props) {
  return (
    <span
      className={clsx(
        'chip font-medium',
        STATUS_COLORS[status],
        size === 'md' && 'px-3 py-1 text-sm',
      )}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}

interface SelectorProps {
  current: TicketStatus;
  onChange: (status: TicketStatus) => void;
}

export function StatusSelector({ current, onChange }: SelectorProps) {
  return (
    <div className="-mx-1 overflow-x-auto px-1 pb-1" role="tablist" aria-label="Saksstatus">
      <div className="flex min-w-max gap-1.5">
        {STATUS_ORDER.map((s) => {
          const selected = current === s;
          return (
            <button
              key={s}
              type="button"
              onClick={() => onChange(s)}
              aria-current={selected ? 'true' : undefined}
              aria-label={`Sett status til ${STATUS_LABELS[s]}${selected ? ' (valgt)' : ''}`}
              className={clsx(
                'rounded-lg border px-3 py-2 text-xs font-medium transition-colors',
                selected
                  ? `${STATUS_COLORS[s]} border-current font-semibold shadow-sm ring-1 ring-current/20`
                  : 'border-transparent bg-slate-100 text-slate-500 hover:border-slate-300 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:hover:border-slate-600 dark:hover:bg-slate-700',
              )}
            >
              {STATUS_LABELS[s]}
            </button>
          );
        })}
      </div>
    </div>
  );
}
